<style lang="scss" scoped>
/deep/ .comp-employee-insurance-history-dialog {
    max-width: 1050px;
    margin-top: 5vh !important;

    .el-dialog__body {
        padding: 12px 18px 18px;
    }
}
</style>

<template>
    <el-dialog :title="title" custom-class="c-el-dialog comp-employee-insurance-history-dialog"
        :visible.sync="showDialog" :before-close="_close">
        <!-- 该员工名下全部绑定：含历史期间/已过期，最新期间在前 -->
        <el-table :data="tableData" style="width: 100%" border size="small">
            <el-table-column label="姓名" prop="name" width="90"></el-table-column>
            <el-table-column label="保单号" prop="policyNumber" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="保险公司" prop="insuranceCompany" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column label="被保人" prop="insuredName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="承保支公司" prop="underwritingBranch" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="保险开始时间" prop="startDate" :formatter="formatDate" width="112"></el-table-column>
            <el-table-column label="保险结束时间" prop="effectiveEndDate" :formatter="formatDate" width="112"></el-table-column>
            <el-table-column label="保险状态" width="96" align="center">
                <template slot-scope="scope">
                    <el-tag size="medium" type="success" v-if="scope.row.insuranceState === 1">{{ scope.row.insuranceStateDesc }}</el-tag>
                    <el-tag size="medium" type="warning" v-if="scope.row.insuranceState === 2">{{ scope.row.insuranceStateDesc }}</el-tag>
                    <el-tag size="medium" type="danger" v-if="scope.row.insuranceState === 3">{{ scope.row.insuranceStateDesc }}</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination-container" v-if="isPagination">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <span slot="footer">
            <el-button type="primary" @click="showDialog = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as funEmployee from "@/api/employees"
import moment from "moment"

export default {
    name: "compEmployeeInsuranceHistory",
    data() {
        return {
            showDialog: false,
            title: "保险历史",
            employee: null,
            tableData: [],
            total: null,
            isPagination: false,
            listQuery: {
                idNumber: "",
                keywords: "",
                page: 1,
                size: 20
            }
        }
    },
    methods: {
        open(row) {
            this.employee = row
            this.listQuery.idNumber = row.idNumber
            this.listQuery.keywords = ""
            this.listQuery.page = 1
            this.title = `「${row.name || ""}」的保险历史`
            this.showDialog = true
            this.getDataList()
        },
        _close() {
            this.showDialog = false
        },
        handleSizeChange(val) {
            this.listQuery.size = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.listQuery.page = val
            this.getDataList()
        },
        getDataList() {
            const params = JSON.parse(JSON.stringify(this.listQuery))
            funEmployee.GetEmployeeInsuranceBindingHistory(params).then(response => {
                this.total = response.totalCount
                this.isPagination = response.totalCount > 0 || false
                this.tableData = (response && response.items) || []
                if (this.employee && this.employee.name) {
                    this.title = `「${this.employee.name}」的保险历史（共 ${response.totalCount || 0} 条）`
                }
            })
        },
        formatDate(row, column, cellValue) {
            return cellValue ? moment(cellValue).format("YYYY-MM-DD") : ""
        }
    }
}
</script>
